import { Directive, ElementRef, Optional } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';

/**
 * This directive is only used as selector of input-wrap wrapped element
 * We select element there so we can retrieve informatin about itts setup not to pass manually
 */
@Directive({
    selector: '[ngModel],[formControl],[formControlName]',
    standalone: true
})
export class InputWrapBodyDirective {
    constructor(
        protected elementRef: ElementRef<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
        @Optional() public ngModel: NgModel,
        @Optional() public ngControl: NgControl
    ) {}

    get nativeElement(): HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement {
        return this.elementRef.nativeElement;
    }
}
